import apiClient from '@/api/apiClient'

export const getAgentNotices = accountId =>
  apiClient.get(`api/v1/accounts/${accountId}/agent_notices`)

export const sendAgentNotice = (accountId, payload) =>
  apiClient.post(`api/v1/accounts/${accountId}/agent_notices`, payload)

export const readAgentNotice = (accountId, id) =>
  apiClient.post(`api/v1/accounts/${accountId}/agent_notices/${id}/read`)
